import { z } from "zod";

import {
  CreateExclusionGroupDtoSchema,
  CreateExclusionGroupEntityDtoSchema,
} from "../dtos/exclusion-group";

export const CreateExclusionGroupEntityFeSchema =
  CreateExclusionGroupEntityDtoSchema.extend({
    experienceId: z.string().uuid().optional(),
  });
export type CreateExclusionGroupEntityFe = z.infer<
  typeof CreateExclusionGroupEntityFeSchema
>;

export const CreateExclusionGroupFeSchema =
  CreateExclusionGroupDtoSchema.extend({
    exclusionGroupEntities: CreateExclusionGroupEntityFeSchema.array().default(
      []
    ),
  });

export type CreateExclusionGroupFe = z.infer<
  typeof CreateExclusionGroupFeSchema
>;
